/**
 * Constants for Episode Evaluation & Testing System
 *
 * These constants control the behavior of the episode testing interface,
 * including safety limits and validation constraints.
 */

/**
 * Maximum number of exchanges allowed in automatic simulation mode.
 *
 * This is a very high safety limit to prevent true infinite loops while
 * allowing long, natural conversations. The user can manually stop the
 * simulation at any time or close the page.
 *
 * Note: Frontend owns all simulation state and loop control.
 */
export const MAX_SIMULATION_EXCHANGES = 1000;

/**
 * Maximum character length for user messages in manual testing mode.
 *
 * This matches the backend validation limit to provide consistent
 * feedback before the request is sent to the server.
 */
export const MAX_USER_MESSAGE_LENGTH = 500;

/**
 * localStorage key for episode creation preference
 *
 * Story: 11.8 - LLM-Assisted Episode Editing
 * Acceptance Criteria: AC 3 - Task 4
 */
export const EPISODE_CREATION_PREFERENCE_KEY = 'episode_creation_preference';
